// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"78":"auth-pages","242":"lend-pages"}[chunkId] + "." + {"78":"44e8ba21","242":"22836354"}[chunkId] + ".css";
};